import { render } from "./ReportDataTableQuarter.vue?vue&type=template&id=12a4a714&scoped=true"
import script from "./ReportDataTableQuarter.vue?vue&type=script&lang=js"
export * from "./ReportDataTableQuarter.vue?vue&type=script&lang=js"

import "./ReportDataTableQuarter.vue?vue&type=style&index=0&id=12a4a714&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12a4a714"]])

export default __exports__